// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FreeSlabVm from "../../../../vm-mapper/FreeSlabVm.bs.js";
import * as Row$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryConfig from "../../../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as LabelUnit$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/label-unit/LabelUnit.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";

function FreeSlabCmp(Props) {
  var free_kms = Props.free_kms;
  var price_per_min = Props.price_per_min;
  var free_slab_data = FreeSlabVm.getVm(free_kms, price_per_min);
  var match = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match.country);
  return React.createElement("div", {
              className: "slab"
            }, React.createElement(Row$Catalyst.make, {
                  children: React.createElement("div", {
                        className: "title"
                      }, "Free KMS"),
                  className: "slab-header"
                }), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Distance Range",
                      unit: "kms"
                    }), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function (_event) {
                              
                            }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: free_slab_data.start_distance
                      }
                    }), React.createElement("div", {
                      className: "label"
                    }, "to"), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function (param) {
                              
                            }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: free_slab_data.end_distance
                      }
                    })), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Price per KM",
                      unit: currency
                    }), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function (param) {
                              
                            }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: free_slab_data.price_per_km
                      }
                    })), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Price per min",
                      unit: currency
                    }), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function (param) {
                              
                            }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: free_slab_data.price_per_min
                      }
                    })));
}

var make = FreeSlabCmp;

export {
  make ,
  
}
/* react Not a pure module */
